module.exports = {
	"config": {
		"siteTitle": "Crypto Christmas"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "2016",
				"stem": "_template",
				"path": "2016/_template.jsx"
			},
			"requirePath": "2016/_template.jsx",
			"templatePath": "/2016/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "1.md",
				"ext": "md",
				"name": "1",
				"extname": ".md",
				"basename": "1.md",
				"dirname": "2016",
				"stem": "1",
				"path": "2016/1.md"
			},
			"requirePath": "2016/1.md",
			"path": "/2016/1/",
			"data": {
				"title": "Come up with your passphrase"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "10.md",
				"ext": "md",
				"name": "10",
				"extname": ".md",
				"basename": "10.md",
				"dirname": "2016",
				"stem": "10",
				"path": "2016/10.md"
			},
			"requirePath": "2016/10.md",
			"path": "/2016/10/",
			"data": {
				"title": "Remove permissions from old devices"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "11.md",
				"ext": "md",
				"name": "11",
				"extname": ".md",
				"basename": "11.md",
				"dirname": "2016",
				"stem": "11",
				"path": "2016/11.md"
			},
			"requirePath": "2016/11.md",
			"path": "/2016/11/",
			"data": {
				"title": "Enable remote device wipes"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "12.md",
				"ext": "md",
				"name": "12",
				"extname": ".md",
				"basename": "12.md",
				"dirname": "2016",
				"stem": "12",
				"path": "2016/12.md"
			},
			"requirePath": "2016/12.md",
			"path": "/2016/12/",
			"data": {
				"title": "Delete it"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "2.md",
				"ext": "md",
				"name": "2",
				"extname": ".md",
				"basename": "2.md",
				"dirname": "2016",
				"stem": "2",
				"path": "2016/2.md"
			},
			"requirePath": "2016/2.md",
			"path": "/2016/2/",
			"data": {
				"title": "Install a password manager"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "3.md",
				"ext": "md",
				"name": "3",
				"extname": ".md",
				"basename": "3.md",
				"dirname": "2016",
				"stem": "3",
				"path": "2016/3.md"
			},
			"requirePath": "2016/3.md",
			"path": "/2016/3/",
			"data": {
				"title": "Use funky robo-passwords"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "4.md",
				"ext": "md",
				"name": "4",
				"extname": ".md",
				"basename": "4.md",
				"dirname": "2016",
				"stem": "4",
				"path": "2016/4.md"
			},
			"requirePath": "2016/4.md",
			"path": "/2016/4/",
			"data": {
				"title": "Encrypt your hard drive"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "5.md",
				"ext": "md",
				"name": "5",
				"extname": ".md",
				"basename": "5.md",
				"dirname": "2016",
				"stem": "5",
				"path": "2016/5.md"
			},
			"requirePath": "2016/5.md",
			"path": "/2016/5/",
			"data": {
				"title": "Get Signal"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "6.md",
				"ext": "md",
				"name": "6",
				"extname": ".md",
				"basename": "6.md",
				"dirname": "2016",
				"stem": "6",
				"path": "2016/6.md"
			},
			"requirePath": "2016/6.md",
			"path": "/2016/6/",
			"data": {
				"title": "Set a lock screen password"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "7.md",
				"ext": "md",
				"name": "7",
				"extname": ".md",
				"basename": "7.md",
				"dirname": "2016",
				"stem": "7",
				"path": "2016/7.md"
			},
			"requirePath": "2016/7.md",
			"path": "/2016/7/",
			"data": {
				"title": "Install some browser extensions"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "8.md",
				"ext": "md",
				"name": "8",
				"extname": ".md",
				"basename": "8.md",
				"dirname": "2016",
				"stem": "8",
				"path": "2016/8.md"
			},
			"requirePath": "2016/8.md",
			"path": "/2016/8/",
			"data": {
				"title": "Update your software"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2016",
				"base": "9.md",
				"ext": "md",
				"name": "9",
				"extname": ".md",
				"basename": "9.md",
				"dirname": "2016",
				"stem": "9",
				"path": "2016/9.md"
			},
			"requirePath": "2016/9.md",
			"path": "/2016/9/",
			"data": {
				"title": "Audit your integrations"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {
				"path": "/404"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.md",
				"ext": "md",
				"name": "about",
				"extname": ".md",
				"basename": "about.md",
				"dirname": "",
				"stem": "about",
				"path": "about.md"
			},
			"requirePath": "about.md",
			"path": "/about/",
			"data": {
				"title": "About"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog",
				"stem": "index",
				"path": "blog/index.md"
			},
			"requirePath": "blog/index.md",
			"path": "/blog/",
			"data": {
				"title": "Blog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 417
// module chunks = 0